import { Controller } from "@hotwired/stimulus";

// Fiche d'un signataire : reprend le nom du membre du personnel choisi,
// affiche les écoles quand la portée n'est pas tout le complexe, et les
// comptes autorisés quand l'usage est restreint.
export default class extends Controller {
  static targets = ["name", "schools", "authorized", "stampSelect", "stampPreview"];

  fillName(event) {
    const option = event.target.selectedOptions[0];
    if (option?.dataset.name && this.hasNameTarget) {
      this.nameTarget.value = option.dataset.name;
    }
  }

  toggleScope(event) {
    if (!this.hasSchoolsTarget) return;
    this.schoolsTarget.style.display = event.target.value === "1" ? "none" : "flex";
  }

  // Montre l'image du cachet administratif choisi.
  showStamp() {
    const chosen = this.stampSelectTarget.value;
    this.stampPreviewTargets.forEach((preview) => {
      preview.style.display = preview.dataset.stampId === chosen ? "block" : "none";
    });
  }

  toggleRestricted(event) {
    if (!this.hasAuthorizedTarget) return;
    this.authorizedTarget.style.display = event.target.checked ? "block" : "none";
  }
}
